export const LoadMoreButton = (props: any) => {
    return <div className="flex items-center justify-center">
        <button onClick={props.onClick} className="w-fit flex flex-row gap-2 mt-3 px-3 py-1 border-1 border-[#0054e6] text-[#0054e6] font-medium text-xs rounded-md">Tampilkan Lebih Banyak</button>
    </div>
}; 